export const OrderItemStatus = {
    NORMAL: 1,
    AFTER_SALE: 2,
    AFTER_SALE_FINISH: 3
}